import { useEffect, useState } from 'react';

/**
 * Today's date, but only once the page is running in the browser. Pre-rendered HTML gets null,
 * so it never bakes in the build day's date (or a month's worth of numbers) as page text.
 */
export default function useBrowserDate() {
  const [date, setDate] = useState(null);
  useEffect(() => setDate(new Date()), []);
  return date;
}
